<template>
  <div class="intro">
    <div class="logo-row">
      <img
        class="logo-row__energy-saver"
        src="../../../assets/logo-occ.svg"
        alt="Energy Saver"
      />
      <img
        class="logo-row__metis"
        src="../../../assets/logo-metis.png"
        alt="Metis"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader'
};
</script>

<style lang="scss">
.intro {
  padding: 16px 15px 12px;
  background: $metis-vision-white;
  border-bottom: 1px solid $metis-muted;
  overflow: hidden;

  .logo-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-width: 0;

    &__energy-saver {
      display: block;
      height: 40px;
      width: auto;
      max-width: 48%;
      object-fit: contain;
      object-position: left center;
      flex: 0 1 auto;
      min-width: 0;
    }

    &__metis {
      display: block;
      height: 48px;
      width: auto;
      max-width: 48%;
      object-fit: contain;
      object-position: right center;
      flex: 0 1 auto;
      min-width: 0;
    }
  }
}
</style>
